import { Cache } from "swr";

const STORAGE_KEY = "swr-cache";

/**
 * LocalStorage-backed cache provider for SWR
 * Persists cache across page reloads and browser sessions
 */
export function localStorageSWRCacheProvider(): Cache {
  // Initialize cache from localStorage
  let map: Map<string, any>;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    map = new Map(stored ? JSON.parse(stored) : []);
  } catch (error) {
    // If localStorage is not available or parsing fails, use empty map
    console.warn("Failed to load SWR cache from localStorage, are we in a server component?");
    map = new Map();
  }

  // Save cache to localStorage before page unload
  if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", () => {
      try {
        const entries = Array.from(map.entries());
        localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
      } catch (error) {
        console.warn("Failed to save SWR cache to localStorage:", error);
      }
    });

    // Also periodically save to localStorage (every 10 seconds)
    // This helps prevent data loss if the page crashes
    setInterval(() => {
      try {
        const entries = Array.from(map.entries());
        localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
      } catch (error) {
        // Silently fail - storage might be full
      }
    }, 10000);
  }

  // Return the map as a Cache
  return map as Cache;
}
